module.exports = __webpack_public_path__ + "static/media/yoho-logo.ef4f9457.png";